var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_diii_90_867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.0774 3.58887C33.6034 3.58899 38.5978 7.3142 41.8381 10.7705C43.4763 12.5178 44.7253 14.2584 45.5657 15.5596C45.9871 16.2121 46.3095 16.759 46.5286 17.1484C46.6381 17.3432 46.7222 17.4992 46.7805 17.6094C46.8096 17.6643 46.8327 17.7078 46.8489 17.7393L46.8674 17.7773L46.8743 17.79L46.8772 17.7959C47.3277 18.6977 46.1464 19.1911 45.2444 18.7402L45.1174 18.6768C46.8777 19.5569 46.8766 19.5598 46.8762 19.5605L46.8743 19.5645L46.8674 19.5762L46.8489 19.6143C46.8327 19.6458 46.8097 19.69 46.7805 19.7451C46.7222 19.8553 46.6381 20.0113 46.5286 20.2061C46.3095 20.5955 45.987 21.1425 45.5657 21.7949C44.7254 23.096 43.4761 24.8358 41.8381 26.583C38.5978 30.0394 33.6035 33.7655 27.0774 33.7656C20.5511 33.7656 15.5561 30.0394 12.3157 26.583C10.6777 24.8358 9.42843 23.096 8.58813 21.7949C8.1669 21.1427 7.84528 20.5955 7.62622 20.2061C7.51673 20.0114 7.43255 19.8553 7.37427 19.7451C7.34512 19.69 7.32213 19.6458 7.30591 19.6143L7.28638 19.5762L7.27856 19.5605L7.27661 19.5576C6.82591 18.6562 8.00702 18.1627 8.90845 18.6133L9.03638 18.6768C7.37957 17.8484 7.28382 17.7976 7.27856 17.7939L7.28052 17.79L7.28638 17.7773L7.30591 17.7393C7.32211 17.7077 7.34522 17.6643 7.37427 17.6094C7.43256 17.4992 7.51664 17.3432 7.62622 17.1484C7.84527 16.759 8.16684 16.2119 8.58813 15.5596C9.42848 14.2584 10.6775 12.5179 12.3157 10.7705C15.5561 7.3141 20.5511 3.58887 27.0774 3.58887ZM27.0774 7.52539C22.1236 7.52539 18.0974 10.3593 15.1877 13.4629C13.751 14.9954 12.6432 16.5355 11.8948 17.6943C11.5082 18.293 11.5082 19.0605 11.8948 19.6592C12.6432 20.818 13.7508 22.3589 15.1877 23.8916C18.0974 26.9952 22.1237 29.8291 27.0774 29.8291C32.0308 29.829 36.0565 26.995 38.9661 23.8916C40.403 22.3589 41.5116 20.818 42.26 19.6592C42.6464 19.0606 42.6466 18.2929 42.26 17.6943C41.5116 16.5355 40.4029 14.9955 38.9661 13.4629C36.0565 10.3594 32.0309 7.52552 27.0774 7.52539ZM27.0774 11.7891C30.8813 11.7893 33.9649 14.8728 33.9651 18.6768C33.9651 22.4808 30.8814 25.5652 27.0774 25.5654C23.2732 25.5654 20.1887 22.4809 20.1887 18.6768C20.1889 14.8727 23.2733 11.7891 27.0774 11.7891ZM27.0774 15.7246C25.4471 15.7246 24.1254 17.0465 24.1252 18.6768C24.1252 20.3071 25.447 21.6289 27.0774 21.6289C28.7076 21.6287 30.0286 20.307 30.0286 18.6768C30.0284 17.0466 28.7075 15.7248 27.0774 15.7246Z",
    fill: "#AEAEB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_diii_90_867",
    x: -0.0000157356,
    y: 0.000114202,
    width: 54.1537,
    height: 44.5318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.58875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.58875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_867",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.58875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_90_867"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.58875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.79438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.42 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_90_867",
    result: "effect3_innerShadow_90_867"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.79438
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.897188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_90_867",
    result: "effect4_innerShadow_90_867"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.cc7e3b21d1145f39117c9021d167f2a8.svg";
export { ForwardRef as ReactComponent };